(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mox-dual-promo"] && !Shopify.designMode) return;
  try {
    
  // MOXIE: slideshow-component avanza por defecto tantos índices como slides
  // simultáneamente visibles (ver assets/slideshow.js get nextIndex/previousIndex).
  // Con 2 cards visibles eso salta de a 2. Acá forzamos que siempre avance/retroceda
  // de a 1 slide (flechas y autoplay propio), sin tocar el componente nativo.
  function moxDualPromoStep(slideshow, forward) {
    const total = slideshow.slides ? slideshow.slides.length : 0;
    if (!total) return;

    let index = slideshow.current + (forward ? 1 : -1);
    if (index >= total) index = slideshow.infinite ? 0 : total - 1;
    if (index < 0) index = slideshow.infinite ? total - 1 : 0;

    slideshow.select(index);
  }

  // Flechas: el framework nativo (assets/component.js) delega TODO click del documento
  // vía un único listener global en fase bubble que lee "on:click" en vivo — no hay forma
  // de interceptarlo por orden/fase de eventos. Se le quita el atributo a las flechas para
  // que ese listener las ignore, y se maneja el click acá con el paso de a 1.
  document.querySelectorAll('.mox-dual-promo-section .slideshow-control--next, .mox-dual-promo-section .slideshow-control--previous').forEach((button) => {
    button.removeAttribute('on:click');
    button.addEventListener('click', (event) => {
      const slideshow = button.closest('slideshow-component');
      if (!slideshow || typeof slideshow.select !== 'function') return;

      event.preventDefault();
      moxDualPromoStep(slideshow, button.classList.contains('slideshow-control--next'));
    });
  });

  // Autoplay propio (el nativo se deja apagado, ver render 'slideshow' en el .liquid).
  document.querySelectorAll('.mox-dual-promo[data-mox-autoplay="true"]').forEach((root) => {
    const slideshow = root.querySelector('slideshow-component');
    if (!slideshow) return;

    const speedSeconds = parseFloat(root.getAttribute('data-mox-autoplay-speed')) || 4;

    setInterval(() => {
      if (slideshow.matches(':hover') || document.hidden) return;
      moxDualPromoStep(slideshow, true);
    }, speedSeconds * 1000);
  });

  } catch(e) { console.error(e); }
})();
})();
